export default __webpack_public_path__ + "static/mazuis-review-regular-956c353279af8ef46996b7434ca0c75e.otf";